import React, { useEffect, useRef, useState } from "react";
import env from "../../config/env";
import {
  Box, Button, Dialog, DialogActions, DialogContent, DialogTitle,
  IconButton, Paper, Table, TableBody, TableCell, TableContainer,
  TableHead, TableRow, TextField, Typography, Snackbar, Alert,
  TablePagination, CircularProgress, FormControl, InputLabel, Select, MenuItem, Checkbox, ListItemText,
  ToggleButton, ToggleButtonGroup, InputAdornment, Popover, useTheme
} from "@mui/material";
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { LocalizationProvider, DesktopDatePicker } from '@mui/x-date-pickers';
import { Add as AddIcon, Delete as DeleteIcon, Edit as EditIcon, 
         PlayArrow as PlayIcon, Stop as StopIcon, Schedule as ScheduleIcon,
         CalendarToday as CalendarIcon, FilterList as FilterIcon,
         Visibility as VisibilityIcon, Close as CloseIcon,
         AccessTime as AccessTimeIcon, ThumbUp as ThumbUpIcon,
         Block as BlockIcon, Lightbulb as LightbulbIcon,
         ThumbDown as ThumbDownIcon, Traffic as TrafficIcon,
         School as SchoolIcon, WbSunny as SunIcon } from "@mui/icons-material";
import api from "../../services/api";
import AcessoRestrito from '../../components/AcessoRestrito';
import { format, parseISO } from "date-fns";
import { ptBR } from "date-fns/locale";

const drawerWidth = 280;

export default function HorarioAtendimento() {
  // Adicionar estilos CSS para animações
  React.useEffect(() => {
    const style = document.createElement('style');
    style.textContent = `
      @keyframes pulse {
        0% { opacity: 1; transform: scale(1); }
        50% { opacity: 0.5; transform: scale(1.2); }
        100% { opacity: 1; transform: scale(1); }
      }
    `;
    document.head.appendChild(style);
    return () => document.head.removeChild(style);
  }, []);

  const [horarios, setHorarios] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [openForm, setOpenForm] = useState(false);
  const [openView, setOpenView] = useState(false);
  const [horarioParaVisualizar, setHorarioParaVisualizar] = useState(null);
  const [formData, setFormData] = useState({
    codigoTurma: '',
    nome: '',
    diaInicio: '',
    diaFim: '',
    duracao_minuto: '',
    horaInicio: '',
    horaFim: '',
    local: '',
    colaboradorCargo: '',
    colaboradorDepartamento: '',
    colaborador: '',
    situacao: 'aberto',
    st_codHashEmpresa: localStorage.getItem("st_codHashEmpresa") || '',
    diasSelecionados: [],
    diasFuncionamento: [],
    capacidade: '',
    andar: '',
    bloco: '',
    numeroMaximoClientes: 10,
    servico: ''
  });
  const [horarioSelecionado, setHorarioSelecionado] = useState(null);
  const [formErrors, setFormErrors] = useState({});
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);


  // Estados para locais e colaboradores
  const [locais, setLocais] = useState([]);
  const [colaboradores, setColaboradores] = useState([]);
  const [colaboradoresDisponiveis, setColaboradoresDisponiveis] = useState([]);
  const [loadingDisponibilidade, setLoadingDisponibilidade] = useState(false);
  const [servicos, setServicos] = useState([]);

  // Estados para filtros
  const [filtros, setFiltros] = useState({
    periodoInicio: '',
    periodoFim: '',
    situacao: '',
    status: '',
    local: '',
    colaborador: '',
    servico: '',
    nome: '',
    codigoTurma: ''
  });

  const servicoColaboradoresCacheRef = useRef(new Map());

  // Função para criar logs de autenticação
  // Função de log de auditoria removida - agora é feita no backend

  useEffect(() => {
    carregarHorariosAtendimento();
  }, []);

  // Salvar filtros no localStorage quando mudarem
  useEffect(() => {
    if (temFiltrosAtivos()) {
      localStorage.setItem('horarios_filtros', JSON.stringify(filtros));
    } else {
      localStorage.removeItem('horarios_filtros');
    }
  }, [filtros]);

  useEffect(() => {
    servicoColaboradoresCacheRef.current.clear();
  }, [servicos, colaboradores]);

  useEffect(() => {
    carregarHorarios();
    carregarLocais();
    carregarColaboradores();
    carregarServicos();
  }, []);

  // Monitorar mudanças no estado de serviços
  useEffect(() => {
    // Estado de serviços atualizado
  }, []); // Sem dependências para evitar loops

  // Limpar colaborador quando o serviço mudar (apenas para novos horários)
  useEffect(() => {
    if (openForm && formData.servico && !horarioSelecionado) {
      // Limpar colaborador selecionado quando o serviço muda (apenas para novos horários)
      setFormData(prev => ({ 
        ...prev, 
        colaborador: '',
        colaboradorCargo: '',
        colaboradorDepartamento: ''
      }));
      setColaboradoresDisponiveis([]);
    }
  }, [formData.servico, openForm, horarioSelecionado]);

  // Carregar colaboradores disponíveis quando o formulário é aberto para edição
  useEffect(() => {
    if (openForm && horarioSelecionado && formData.servico) {
      
      // Se estamos editando um horário e já temos o serviço, carregar colaboradores disponíveis
      const carregarColaboradoresParaEdicao = async () => {
        try {
          setLoadingDisponibilidade(true);
          const token = localStorage.getItem("token");
          const headers = {
            'Authorization': `Bearer ${token}`,
            'x-second-key': env.SECOND_SECRET_KEY
          };

          const colaboradoresDoServico = await obterColaboradoresDoServico(formData.servico, headers);
          const disponibilidadesData = await obterDisponibilidades(headers);

          const colaboradoresDisponiveisFiltrados = colaboradoresDoServico.filter((colaborador) => {
            const disponibilidades = (disponibilidadesData || []).filter((d) =>
              d.id_colaborador === colaborador.id || d.colaboradorId === colaborador.id
            );

            return verificarDisponibilidadeColaborador(
              disponibilidades,
              formData.diasSelecionados,
              formData.horaInicio,
              formData.duracao_minuto
            );
          });

          setColaboradoresDisponiveis(colaboradoresDisponiveisFiltrados);

        } catch (err) {
          console.error('❌ Erro ao carregar colaboradores para edição:', err);
          setColaboradoresDisponiveis([]);
        } finally {
          setLoadingDisponibilidade(false);
        }
      };

      carregarColaboradoresParaEdicao();
    }
  }, [openForm, horarioSelecionado, formData.servico, formData.diasSelecionados, formData.horaInicio, formData.duracao_minuto]);

  // Consultar disponibilidade quando os critérios mudarem
  useEffect(() => {
    if (openForm) {
      // Só consultar disponibilidade se todos os campos necessários estiverem preenchidos
      const todosCamposPreenchidos = formData.nome && 
                                    formData.diaInicio && 
                                    formData.diaFim && 
                                    formData.duracao_minuto && 
                                    formData.diasSelecionados && 
                                    formData.diasSelecionados.length > 0 && 
                                    formData.horaInicio;
      
      if (todosCamposPreenchidos) {
        consultarDisponibilidade();
      } else {
        // Limpar colaboradores disponíveis se algum campo necessário não estiver preenchido
        setColaboradoresDisponiveis([]);
        setLoadingDisponibilidade(false);
      }
    }
  }, [
    formData.nome,
    formData.diaInicio,
    formData.diaFim,
    formData.duracao_minuto,
    formData.diasSelecionados, 
    formData.horaInicio,
    formData.servico,
    openForm
  ]);

  // Limpar colaborador selecionado quando a lista de disponíveis mudar
  useEffect(() => {
    if (openForm && colaboradoresDisponiveis.length > 0) {
      // Verificar se o colaborador selecionado ainda está na lista de disponíveis
      const colaboradorAindaDisponivel = colaboradoresDisponiveis.find(c => c.id === formData.colaborador);
      if (!colaboradorAindaDisponivel) {
        setFormData(prev => ({
          ...prev,
          colaborador: '',
          colaboradorCargo: '',
          colaboradorDepartamento: ''
        }));
      }
    }
  }, [colaboradoresDisponiveis, openForm, formData.colaborador]);

  // Resetar página quando filtros mudarem
  useEffect(() => {
    setPage(0);
  }, [filtros]);

  const carregarHorarios = async () => {
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const codHashEmpresa = localStorage.getItem("st_codHashEmpresa");
      const headers = {
        'Authorization': `Bearer ${token}`,
        'x-second-key': env.SECOND_SECRET_KEY
      };
      const res = await api.get(`/horarioAtendimento?st_codHashEmpresa=${codHashEmpresa}`, { headers });
      if (res.data && res.data.length > 0) {
        // Dados carregados com sucesso
      }
      setHorarios(res.data || []);
    } catch (err) {
      console.error('Erro ao carregar horários:', err);
      setError('Erro ao carregar horários');
    } finally {
      setLoading(false);
    }
  };

  const carregarLocais = async () => {
    try {
      const token = localStorage.getItem("token");
      const codHashEmpresa = localStorage.getItem("st_codHashEmpresa");
      const headers = {
        'Authorization': `Bearer ${token}`,
        'x-second-key': env.SECOND_SECRET_KEY
      };
      const res = await api.get(`/local?st_codHashEmpresa=${codHashEmpresa}`, { headers });
      setLocais(res.data || []);
      // Log de auditoria removido - agora é feito no backend
    } catch (error) {
      console.error('Erro ao carregar locais:', error);
    }
  };

  const carregarColaboradores = async () => {
    try {
      const token = localStorage.getItem("token");
      const codHashEmpresa = localStorage.getItem("st_codHashEmpresa");
      const headers = {
        'Authorization': `Bearer ${token}`,
        'x-second-key': env.SECOND_SECRET_KEY
      };
      const res = await api.get(`/colaboradores?st_codHashEmpresa=${codHashEmpresa}`, { headers });
      setColaboradores(res.data || []);
      // Log de auditoria removido - agora é feito no backend
    } catch (error) {
      console.error('Erro ao carregar colaboradores:', error);
    }
  };

  const carregarServicos = async () => {
    try {
      const token = localStorage.getItem("token");
      const headers = {
        'Authorization': `Bearer ${token}`,
        'x-second-key': env.SECOND_SECRET_KEY
      };
      const res = await api.get('/servicos', { headers });
      
      // A API retorna os dados dentro de res.data.dados
      const servicosData = res.data?.dados || [];
      setServicos(servicosData);
      // Log de auditoria removido - agora é feito no backend
    } catch (error) {
      console.error('Erro ao carregar serviços:', error);
    }
  };

  const obterColaboradoresDoServico = async (servicoId, headers) => {
    if (!servicoId) {
      return [];
    }

    const cacheKey = String(servicoId);
    if (servicoColaboradoresCacheRef.current.has(cacheKey)) {
      return servicoColaboradoresCacheRef.current.get(cacheKey);
    }

    const resposta = await api.get(`/servico-colaboradores/${servicoId}`, { headers });
    const dadosResposta = Array.isArray(resposta.data)
      ? resposta.data
      : Array.isArray(resposta.data?.colaboradores)
        ? resposta.data.colaboradores
        : [];

    const colaboradoresMap = new Map(
      (colaboradores || []).map((colab) => [String(colab.id), colab])
    );

    const colaboradoresNormalizados = dadosResposta.map((colaboradorServico) => {
      const colabLocal = colaboradoresMap.get(String(colaboradorServico.id)) || {};
      return {
        id: colaboradorServico.id,
        nome_completo: colaboradorServico.nome_completo
          || colaboradorServico.nome
          || colabLocal.nome_completo
          || colabLocal.nome
          || '',
        cargo: colabLocal.cargo
          || colaboradorServico.cargo
          || '',
        departamento: colabLocal.departamento
          || colabLocal.setor
          || colaboradorServico.departamento
          || colaboradorServico.setor
          || ''
      };
    });

    servicoColaboradoresCacheRef.current.set(cacheKey, colaboradoresNormalizados);
    return colaboradoresNormalizados;
  };

  const obterDisponibilidades = async (headers) => {
    const resposta = await api.get('/disponibilidade', { headers });
    return resposta.data || [];
  };

  const gerarCodigoTurma = () => {
    const codigo = Math.random().toString(36).substr(2, 9).toUpperCase();
    return codigo;
  };

  // Função para carregar horários de atendimento (alias para carregarHorarios)
  const carregarHorariosAtendimento = async () => {
    await carregarHorarios();
  };

  // Função para formatar data para ISO
  const formatarDataParaISO = (data) => {
    if (!data) return '';
    // Se a data já está no formato ISO, retorna como está
    if (data.includes('T') || data.includes('-')) {
      return data;
    }
    // Se está no formato DD/MM/AAAA, converte para ISO
    if (data.includes('/')) {
      const [dia, mes, ano] = data.split('/');
      return `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`;
    }
    return data;
  };

  const handleOpenForm = (horario = null) => {
    if (horario) {
      // Converter datas do formato YYYY-MM-DD para DD/MM/AAAA para exibição
      const formatarDataParaExibicao = (dataISO) => {
        if (!dataISO) return '';
        const data = new Date(dataISO);
        return `${String(data.getDate()).padStart(2, '0')}/${String(data.getMonth() + 1).padStart(2, '0')}/${data.getFullYear()}`;
      };
      
      const formDataToSet = { 
        ...horario,
        diaInicio: formatarDataParaExibicao(horario.diaInicio),
        diaFim: formatarDataParaExibicao(horario.diaFim),
        // Mapear diasDaSemana para diasSelecionados
        diasSelecionados: horario.diasDaSemana || horario.diasSelecionados || [],
        // Garantir que outros campos existam
        diasFuncionamento: horario.diasFuncionamento || [],
        capacidade: horario.capacidade || '',
        andar: horario.andar || '',
        bloco: horario.bloco || '',
        numeroMaximoClientes: horario.numeroMaximoClientes || 10,
        // Garantir que st_codHashEmpresa seja sempre preenchido
        st_codHashEmpresa: horario.st_codHashEmpresa || localStorage.getItem("st_codHashEmpresa") || '',
        // Mapear servicoId para servico (para compatibilidade com o formulário)
        servico: horario.servicoId || horario.servico || ''
      };
      
      setFormData(formDataToSet);
      setHorarioSelecionado(horario);
    } else {
      setFormData({
        codigoTurma: gerarCodigoTurma(),
        nome: '',
        diaInicio: '',
        diaFim: '',
        duracao_minuto: '',
        horaInicio: '',
        horaFim: '',
        local: '',
        colaboradorCargo: '',
        colaboradorDepartamento: '',
        colaborador: '',
        situacao: 'aberto',
        st_codHashEmpresa: localStorage.getItem("st_codHashEmpresa") || '',
        diasSelecionados: [],
        diasFuncionamento: [],
        capacidade: '',
        andar: '',
        bloco: '',
        numeroMaximoClientes: 10,
        servico: ''
      });
      setHorarioSelecionado(null);
    }
    setOpenForm(true);
  };

  const handleCloseForm = () => {
    setOpenForm(false);
    setFormData({
      codigoTurma: '',
      nome: '',
      diaInicio: '',
      diaFim: '',
      duracao_minuto: '',
      horaInicio: '',
      horaFim: '',
      local: '',
      colaboradorCargo: '',
      colaboradorDepartamento: '',
      colaborador: '',
      situacao: 'aberto',
      st_codHashEmpresa: localStorage.getItem("st_codHashEmpresa") || '',
      diasSelecionados: [],
      diasFuncionamento: [],
      capacidade: '',
      andar: '',
      bloco: '',
      numeroMaximoClientes: 10,
      servico: ''
    });
    setHorarioSelecionado(null);
    setFormErrors({});
    setColaboradoresDisponiveis([]);
    setLoadingDisponibilidade(false);
  };

  const handleOpenView = async (horario) => {
    
    // Garantir que os dados necessários estejam carregados
    if (servicos.length === 0) {
      await carregarServicos();
    }
    if (locais.length === 0) {
      await carregarLocais();
    }
    
    setHorarioParaVisualizar(horario);
    setOpenView(true);
  };

  const handleCloseView = () => {
    setOpenView(false);
    setHorarioParaVisualizar(null);
  };

  // Função auxiliar para buscar serviço por ID (aceita string e number)
  const buscarServicoPorId = (servicoId) => {
    if (!servicoId) {
      return null;
    }
    
    // Buscar tanto por servicoId quanto por servico (para compatibilidade)
    const servicoEncontrado = servicos.find(s => String(s.id) === String(servicoId));
    
    return servicoEncontrado;
  };

  // Função auxiliar para buscar colaborador por ID (aceita string e number)
  const buscarColaboradorPorId = (colaboradorId) => {
    if (!colaboradorId) return null;
    
    const colaboradorEncontrado = colaboradores.find(c => String(c.id) === String(colaboradorId));
    
    return colaboradorEncontrado;
  };

  // Função auxiliar para buscar local por ID (aceita string e number)
  const buscarLocalPorId = (localId) => {
    if (!localId) return null;
    
    const localEncontrado = locais.find(l => String(l.id) === String(localId));
    
    return localEncontrado;
  };

  const validar = () => {
    const errors = {};
    if (!formData.nome) errors.nome = true;
    if (!formData.diaInicio) errors.diaInicio = true;
    if (!formData.diaFim) errors.diaFim = true;
    if (!formData.duracao_minuto) errors.duracao_minuto = true;
    if (!formData.horaInicio) errors.horaInicio = true;
    if (!formData.local) errors.local = true;
    if (!formData.colaboradorCargo) errors.colaboradorCargo = true;
    if (!formData.colaboradorDepartamento) errors.colaboradorDepartamento = true;
    if (!formData.colaborador) errors.colaborador = true;
    if (!formData.situacao) errors.situacao = true;
    if (!formData.st_codHashEmpresa) errors.st_codHashEmpresa = true;
    if (!formData.diasSelecionados || !formData.diasSelecionados.length) errors.diasSelecionados = true;
    if (!formData.numeroMaximoClientes || formData.numeroMaximoClientes < 1) errors.numeroMaximoClientes = true;
    if (!formData.servico) errors.servico = true;
    
    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleSalvar = async () => {
    if (!validar()) return;
    setLoading(true);
    try {
      const token = localStorage.getItem("token");
      const codHashEmpresa = localStorage.getItem("st_codHashEmpresa");
      
      if (!codHashEmpresa) {
        setError('Código da empresa não encontrado. Faça login novamente.');
        return;
      }
      
      const headers = {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
        'x-second-key': env.SECOND_SECRET_KEY
      };
      
      // Garantir que o serviço seja um valor válido (número ou UUID)
      const servicoId = formData.servico;
      if (!servicoId) {
        setError('Serviço é obrigatório');
        setLoading(false);
        return;
      }
      
      // Se for um número, converter para Number, senão manter como string (UUID)
      const servicoFinal = !isNaN(Number(servicoId)) ? Number(servicoId) : servicoId;
      
      const payload = { 
        ...formData, 
        local: Number(formData.local), 
        colaborador: Number(formData.colaborador), 
        duracao_minuto: Number(formData.duracao_minuto), 
        st_codHashEmpresa: codHashEmpresa,
        servicoId: servicoFinal, // Mudança: usar servicoId em vez de servico
        // Converter datas do formato DD/MM/AAAA para YYYY-MM-DD
        diaInicio: formatarDataParaISO(formData.diaInicio),
        diaFim: formatarDataParaISO(formData.diaFim),
        // Manter tanto diasDaSemana quanto diasSelecionados para compatibilidade
        diasDaSemana: formData.diasSelecionados,
        diasSelecionados: formData.diasSelecionados,
        // Remover campos que não devem ser enviados
        diasFuncionamento: undefined
      };

      if (horarioSelecionado) {
        const id = horarioSelecionado.agendamentoId || horarioSelecionado.id || horarioSelecionado._id;
        if (!id) {
          setError('ID do horário não encontrado para atualização');
          return;
        }
      } else {
        // Criar novo horário
        // Endpoint correto segue o padrão usado no GET: /horarioAtendimento
        await api.post('/horarioAtendimento', payload, { headers });
        setSuccess('Horário criado com sucesso!');
      }
      
      handleCloseForm();
      carregarHorarios();
    } catch (err) {
      console.error('❌ Erro completo ao salvar:', err);
      const mensagemErro = err.response?.data?.message || 
                          err.response?.data?.error || 
                          err.response?.data?.erro || 
                          'Erro ao salvar horário';
      setError(mensagemErro);
    } finally {
      setLoading(false);
    }
  };

  const handleExcluir = async (horario) => {
    if (!horario) {
      console.error("❌ Nenhum horário selecionado para exclusão");
      setError('Nenhum horário selecionado para exclusão');
      return;
    }

    const id = horario.agendamentoId || horario.id || horario._id;
    if (!id) {
      console.error("❌ ID do horário é undefined ou null");
      setError('ID do horário inválido');
      return;
    }

    if (!window.confirm('Deseja realmente excluir este horário?')) return;
    
    setLoading(true);
    try {
    } catch (err) {
      console.error('❌ Erro completo:', err);
      const mensagemErro = err.response?.data?.message || 
                          err.response?.data?.error || 
                          err.response?.data?.erro || 
                          'Erro ao excluir horário';
      setError(mensagemErro);
    } finally {
      setLoading(false);
    }
  };

  // Função para verificar sobreposição de horários
  const verificarSobreposicao = (horario, todosHorarios) => {
    return todosHorarios.some(outroHorario => {
      // Não comparar com ele mesmo - verificar diferentes tipos de ID
      const idHorario = horario.id || horario._id;
      const idOutro = outroHorario.id || outroHorario._id;
      
      if (idHorario === idOutro) {
        return false;
      }
      
      // Verificar se os locais são iguais primeiro (mais rápido)
      if (horario.local !== outroHorario.local) {
        return false;
      }
      
      // Verificar se os períodos se sobrepõem
      const inicioA = new Date(horario.diaInicio);
      const fimA = new Date(horario.diaFim);
      const inicioB = new Date(outroHorario.diaInicio);
      const fimB = new Date(outroHorario.diaFim);
      
      const periodosSobrepoem = (inicioA <= fimB && fimA >= inicioB);
      
      if (!periodosSobrepoem) {
        return false;
      }
      
      // Verificar se os horários se sobrepõem
      const calcularHorarioFim = (horaInicio, duracaoMinutos) => {
        const [horas, minutos] = horaInicio.split(':').map(Number);
        const data = new Date();
        data.setHours(horas);
        data.setMinutes(minutos);
        data.setMinutes(data.getMinutes() + duracaoMinutos);
        return `${String(data.getHours()).padStart(2, '0')}:${String(data.getMinutes()).padStart(2, '0')}`;
      };
      
      const fimHorarioA = calcularHorarioFim(horario.horaInicio, horario.duracao_minuto);
      const fimHorarioB = calcularHorarioFim(outroHorario.horaInicio, outroHorario.duracao_minuto);
      
      // Converter horários para minutos para facilitar comparação
      const converterParaMinutos = (horario) => {
        const [horas, minutos] = horario.split(':').map(Number);
        return horas * 60 + minutos;
      };
      
      const inicioMinA = converterParaMinutos(horario.horaInicio);
      const fimMinA = converterParaMinutos(fimHorarioA);
      const inicioMinB = converterParaMinutos(outroHorario.horaInicio);
      const fimMinB = converterParaMinutos(fimHorarioB);
      
      const horariosSobrepoem = (inicioMinA < fimMinB && fimMinA > inicioMinB);
      
      return horariosSobrepoem;
    });
  };

  // Função para calcular status baseado no período
  const calcularStatus = (diaInicio, diaFim) => {
    const hoje = new Date();
    const inicio = new Date(diaInicio);
    const fim = new Date(diaFim);
    
    // Remover horário para comparar apenas as datas
    hoje.setHours(0, 0, 0, 0);
    inicio.setHours(0, 0, 0, 0);
    fim.setHours(0, 0, 0, 0);
    
    if (hoje >= inicio && hoje <= fim) {
      return 'Em Andamento';
    } else if (hoje > fim) {
      return 'Encerrada';
    } else {
      return 'Breve';
    }
  };

  // Função para ordenar horários por período, horário, local e nome
  const ordenarHorarios = (horarios) => {
    return horarios.sort((a, b) => {
      // 1. Ordenar por data de início (período)
      const dataA = new Date(a.diaInicio);
      const dataB = new Date(b.diaInicio);
      if (dataA.getTime() !== dataB.getTime()) {
        return dataA.getTime() - dataB.getTime();
      }
      
      // 2. Se as datas forem iguais, ordenar por horário
      if (a.horaInicio !== b.horaInicio) {
        return a.horaInicio.localeCompare(b.horaInicio);
      }
      
      // 3. Se os horários forem iguais, ordenar por local
      const localA = locais.find(l => l.id === a.local)?.nome || '';
      const localB = locais.find(l => l.id === b.local)?.nome || '';
      if (localA !== localB) {
        return localA.localeCompare(localB);
      }
      
      // 4. Se os locais forem iguais, ordenar por nome
      return a.nome.localeCompare(b.nome);
    });
  };

  // Aplicar ordenação aos horários
  const horariosOrdenados = ordenarHorarios([...horarios]);

  // Função para aplicar filtros
  const aplicarFiltros = (horarios) => {
    return horarios.filter(horario => {
      // Filtro por código da turma
      if (filtros.codigoTurma && !horario.codigoTurma?.toLowerCase().includes(filtros.codigoTurma.toLowerCase())) {
        return false;
      }

      // Filtro por nome
      if (filtros.nome && !horario.nome.toLowerCase().includes(filtros.nome.toLowerCase())) {
        return false;
      }

      // Filtro por período
      if (filtros.periodoInicio) {
        const dataInicio = new Date(horario.diaInicio);
        const filtroInicio = new Date(filtros.periodoInicio);
        if (dataInicio < filtroInicio) {
          return false;
        }
      }

      if (filtros.periodoFim) {
        const dataFim = new Date(horario.diaFim);
        const filtroFim = new Date(filtros.periodoFim);
        if (dataFim > filtroFim) {
          return false;
        }
      }

      // Filtro por situação
      if (filtros.situacao && horario.situacao !== filtros.situacao) {
        return false;
      }

      // Filtro por status
      if (filtros.status) {
        const status = calcularStatus(horario.diaInicio, horario.diaFim);
        if (status !== filtros.status) {
          return false;
        }
      }

      // Filtro por local
      if (filtros.local && horario.local !== Number(filtros.local)) {
        return false;
      }

      // Filtro por colaborador
      if (filtros.colaborador && horario.colaborador !== Number(filtros.colaborador)) {
        return false;
      }

      // Filtro por serviço
      if (filtros.servico && (horario.servicoId || horario.servico) !== Number(filtros.servico)) {
        return false;
      }

      return true;
    });
  };

  // Aplicar filtros aos horários ordenados
  const horariosFiltrados = aplicarFiltros(horariosOrdenados);

  // Calcular horários com conflito (após filtros)
  const horariosComConflito = horariosFiltrados.filter(horario => 
    verificarSobreposicao(horario, horariosFiltrados)
  );

  // Função para limpar filtros
  const limparFiltros = () => {
    setFiltros({
      periodoInicio: '',
      periodoFim: '',
      situacao: '',
      status: '',
      local: '',
      colaborador: '',
      servico: '',
      nome: '',
      codigoTurma: ''
    });
  };

  // Função para verificar se há filtros ativos
  const temFiltrosAtivos = () => {
    return Object.values(filtros).some(valor => valor !== '');
  };

  // Função para lidar com mudanças nos filtros (padrão colaboradores)
  const handleFiltroChange = (event) => {
    const { name, value } = event.target;
    setFiltros(prev => ({
      ...prev,
      [name]: value
    }));
    setPage(0); // Volta para a primeira página ao filtrar
  };

  // Função para calcular hora fim baseada na hora inicial e duração
  const calcularHoraFim = (horaInicio, duracaoMinutos) => {
    if (!horaInicio || !duracaoMinutos) return '';
    
    const [horas, minutos] = horaInicio.split(':').map(Number);
    const data = new Date();
    data.setHours(horas);
    data.setMinutes(minutos);
    data.setMinutes(data.getMinutes() + Number(duracaoMinutos));
    
    return `${String(data.getHours()).padStart(2, '0')}:${String(data.getMinutes()).padStart(2, '0')}`;
  };

  // Função para converter data de YYYY-MM-DD para DD/MM/AAAA
  const formatarDataParaExibicao = (dataISO) => {
    if (!dataISO) return '';
    try {
      const data = new Date(dataISO);
      if (isNaN(data.getTime())) return '';
      return `${String(data.getDate()).padStart(2, '0')}/${String(data.getMonth() + 1).padStart(2, '0')}/${data.getFullYear()}`;
    } catch (error) {
      console.error('Erro ao formatar data:', error);
      return '';
    }
  };



  // Função para consultar disponibilidade de colaboradores
  const consultarDisponibilidade = async () => {
    try {
      setLoadingDisponibilidade(true);
      const token = localStorage.getItem("token");
      const headers = {
        'Authorization': `Bearer ${token}`,
        'x-second-key': env.SECOND_SECRET_KEY
      };

      const colaboradoresDoServico = await obterColaboradoresDoServico(formData.servico, headers);
      if (colaboradoresDoServico.length === 0) {
        setColaboradoresDisponiveis([]);
        return;
      }

      const disponibilidadesData = await obterDisponibilidades(headers);

      const colaboradoresDisponiveisFiltrados = colaboradoresDoServico.filter((colaborador) => {
        const disponibilidades = (disponibilidadesData || []).filter((d) =>
          d.id_colaborador === colaborador.id || d.colaboradorId === colaborador.id
        );

        return verificarDisponibilidadeColaborador(
          disponibilidades,
          formData.diasSelecionados,
          formData.horaInicio,
          formData.duracao_minuto
        );
      });

      setColaboradoresDisponiveis(colaboradoresDisponiveisFiltrados);

    } catch (err) {
      console.error('❌ Erro ao consultar disponibilidade:', err);
      setColaboradoresDisponiveis([]);
    } finally {
      setLoadingDisponibilidade(false);
    }
  };

  // Função para verificar se um colaborador tem disponibilidade nos dias e horários selecionados
  const verificarDisponibilidadeColaborador = (disponibilidades, diasSelecionados, horaInicio, duracaoMinutos) => {
    if (!disponibilidades || disponibilidades.length === 0) {
      return false;
    }

    // Converter hora de início para minutos para facilitar comparação
    const [horasInicio, minutosInicio] = horaInicio.split(':').map(Number);
    const inicioMinutos = horasInicio * 60 + minutosInicio;
    
    // Calcular hora de fim
    const fimMinutos = inicioMinutos + Number(duracaoMinutos);

    // Verificar cada dia selecionado
    for (const dia of diasSelecionados) {
      // Encontrar disponibilidade para este dia
      const disponibilidadeDia = disponibilidades.find(d => d.dia === dia);
      
      if (!disponibilidadeDia) {
        return false;
      }

      // Converter horários de disponibilidade para minutos
      const [horasDispInicio, minutosDispInicio] = disponibilidadeDia.inicio.split(':').map(Number);
      const [horasDispFim, minutosDispFim] = disponibilidadeDia.fim.split(':').map(Number);
      const dispInicioMinutos = horasDispInicio * 60 + minutosDispInicio;
      const dispFimMinutos = horasDispFim * 60 + minutosDispFim;

      // Verificar se o horário solicitado está dentro da disponibilidade
      const horarioDentroDaDisponibilidade = inicioMinutos >= dispInicioMinutos && fimMinutos <= dispFimMinutos;
      
      if (!horarioDentroDaDisponibilidade) {
        return false;
      }
    }

    return true;
  };

  // Função para verificar se os campos devem estar habilitados
  const isFieldEnabled = (fieldName) => {
    switch (fieldName) {
      case 'nome':
        return true; // Sempre habilitado
      
      case 'diaInicio':
        return !!formData.nome; // Habilitado quando nome estiver preenchido
      
      case 'diaFim':
        return !!formData.nome && !!formData.diaInicio; // Habilitado quando nome e dia início estiverem preenchidos
      
      case 'duracao_minuto':
        return !!formData.nome && !!formData.diaInicio && !!formData.diaFim; // Habilitado quando nome, dia início e dia fim estiverem preenchidos
      
      case 'diasSelecionados':
        return !!formData.nome && !!formData.diaInicio && !!formData.diaFim && !!formData.duracao_minuto; // Habilitado quando nome, datas e duração estiverem preenchidos
      
      case 'horaInicio':
        return !!formData.nome && !!formData.diaInicio && !!formData.diaFim && !!formData.duracao_minuto && formData.diasSelecionados.length > 0; // Habilitado quando nome, datas, duração e dias da semana estiverem preenchidos
      
      case 'local':
        return !!formData.nome && !!formData.diaInicio && !!formData.diaFim && !!formData.duracao_minuto && formData.diasSelecionados.length > 0 && !!formData.horaInicio; // Habilitado quando nome, datas, duração, dias da semana e hora início estiverem preenchidos
      
      case 'numeroMaximoClientes':
        return !!formData.nome && !!formData.diaInicio && !!formData.diaFim && !!formData.duracao_minuto && formData.diasSelecionados.length > 0 && !!formData.horaInicio && !!formData.local; // Habilitado quando nome, datas, duração, dias da semana, hora início e local estiverem preenchidos
      
      case 'servico':
        return !!formData.nome && !!formData.diaInicio && !!formData.diaFim && !!formData.duracao_minuto && formData.diasSelecionados.length > 0 && !!formData.horaInicio && !!formData.local; // Habilitado quando nome, datas, duração, dias da semana, hora início e local estiverem preenchidos
      
      case 'colaborador':
        return !!formData.nome && !!formData.diaInicio && !!formData.diaFim && !!formData.duracao_minuto && formData.diasSelecionados.length > 0 && !!formData.horaInicio && !!formData.servico && !loadingDisponibilidade; // Habilitado quando todos os campos anteriores estiverem preenchidos e não estiver carregando disponibilidade
      
      default:
        return true;
    }
  };

  // Função para obter texto de ajuda para campos desabilitados
  const getDisabledFieldHelperText = (fieldName) => {
    switch (fieldName) {
      case 'diaInicio':
        return !formData.nome ? "Preencha o nome primeiro" : "";
      
      case 'diaFim':
        return !formData.nome ? "Preencha o nome primeiro" : 
               !formData.diaInicio ? "Selecione a data de início primeiro" : "";
      
      case 'duracao_minuto':
        return !formData.nome ? "Preencha o nome primeiro" : 
               !formData.diaInicio ? "Selecione a data de início primeiro" : 
               !formData.diaFim ? "Selecione a data de fim primeiro" : "";
      
      case 'diasSelecionados':
        return !formData.nome ? "Preencha o nome primeiro" : 
               !formData.diaInicio ? "Selecione a data de início primeiro" : 
               !formData.diaFim ? "Selecione a data de fim primeiro" : 
               !formData.duracao_minuto ? "Preencha a duração primeiro" : "";
      
      case 'horaInicio':
        return !formData.nome ? "Preencha o nome primeiro" : 
               !formData.diaInicio ? "Selecione a data de início primeiro" : 
               !formData.diaFim ? "Selecione a data de fim primeiro" : 
               !formData.duracao_minuto ? "Preencha a duração primeiro" : 
               formData.diasSelecionados.length === 0 ? "Selecione os dias da semana primeiro" : "";
      
      case 'local':
        return !formData.nome ? "Preencha o nome primeiro" : 
               !formData.diaInicio ? "Selecione a data de início primeiro" : 
               !formData.diaFim ? "Selecione a data de fim primeiro" : 
               !formData.duracao_minuto ? "Preencha a duração primeiro" : 
               formData.diasSelecionados.length === 0 ? "Selecione os dias da semana primeiro" : 
               !formData.horaInicio ? "Selecione a hora de início primeiro" : "";
      
      case 'numeroMaximoClientes':
        return !formData.nome ? "Preencha o nome primeiro" : 
               !formData.diaInicio ? "Selecione a data de início primeiro" : 
               !formData.diaFim ? "Selecione a data de fim primeiro" : 
               !formData.duracao_minuto ? "Preencha a duração primeiro" : 
               formData.diasSelecionados.length === 0 ? "Selecione os dias da semana primeiro" : 
               !formData.horaInicio ? "Selecione a hora de início primeiro" : 
               !formData.local ? "Selecione o local primeiro" : "";
      
      case 'servico':
        return !formData.nome ? "Preencha o nome primeiro" : 
               !formData.diaInicio ? "Selecione a data de início primeiro" : 
               !formData.diaFim ? "Selecione a data de fim primeiro" : 
               !formData.duracao_minuto ? "Preencha a duração primeiro" : 
               formData.diasSelecionados.length === 0 ? "Selecione os dias da semana primeiro" : 
               !formData.horaInicio ? "Selecione a hora de início primeiro" : 
               !formData.local ? "Selecione o local primeiro" : "";
      
      case 'colaborador':
        return !formData.nome ? "Preencha o nome primeiro" : 
               !formData.diaInicio ? "Selecione a data de início primeiro" : 
               !formData.diaFim ? "Selecione a data de fim primeiro" : 
               !formData.duracao_minuto ? "Preencha a duração primeiro" : 
               formData.diasSelecionados.length === 0 ? "Selecione os dias da semana primeiro" : 
               !formData.horaInicio ? "Selecione a hora de início primeiro" : 
               !formData.servico ? "Selecione o serviço primeiro" : "";
      
      default:
        return "";
    }
  };


  return (
    <AcessoRestrito modulo="horarioatendimento">
      <Box
        sx={{
          height: '100%',
          width: '100%',
          display: 'flex',
          flexDirection: 'column'
        }}
      >
        <Snackbar 
          open={!!error} 
          autoHideDuration={6000} 
          onClose={() => setError(null)}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <Alert onClose={() => setError(null)} severity="error" sx={{ width: '100%' }}>
            {error}
          </Alert>
        </Snackbar>
        <Snackbar 
          open={!!success} 
          autoHideDuration={6000} 
          onClose={() => setSuccess(null)}
          anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        >
          <Alert onClose={() => setSuccess(null)} severity="success" sx={{ width: '100%' }}>
            {success}
          </Alert>
        </Snackbar>
        {/* Box interno com margens de 1,5% */}
        <Box sx={{
          margin: '0 1.5% 1.5% 1.5%',  // 1,5% nas laterais e inferior
          height: '90vh',
          display: 'flex',
          flexDirection: 'column'
        }}>
          <Box sx={{ 
            p: { xs: 2, sm: 3 }, 
            pb: 2,
            display: 'flex', 
            justifyContent: 'space-between', 
            alignItems: { xs: 'flex-start', sm: 'center' },
            flexDirection: { xs: 'column', sm: 'row' },
            gap: { xs: 2, sm: 0 }
          }}>
            <Typography 
              variant="h5" 
              mb={1} 
              sx={{ 
                fontSize: { xs: '1.5rem', sm: '2rem' },
                display: 'flex',
                alignItems: 'center',
                gap: 1
              }}
            >
              <AccessTimeIcon sx={{ 
                fontSize: { xs: '1.5rem', sm: '2rem' },
                color: '#FFC107' // Mesma cor usada no menu lateral
              }} />
              Gestão de Horários
            </Typography>
            <Box sx={{ display: 'flex', gap: 2, alignItems: 'center' }}>
              <Button 
                variant="contained" 
                onClick={() => handleOpenForm()}
                sx={{
                  width: { xs: '100%', sm: 'auto' },
                  minWidth: { xs: 'auto', sm: '200px' },
                  backgroundColor: (theme) => theme.palette.mode === 'dark'
                    ? '#ffffff'
                    : theme.palette.primary.main,
                  color: (theme) => theme.palette.mode === 'dark'
                    ? '#000000'
                    : theme.palette.primary.contrastText,
                  '&:hover': {
                    backgroundColor: (theme) => theme.palette.mode === 'dark'
                      ? '#f5f5f5'
                      : theme.palette.primary.dark,
                  }
                }}
              >
                <AddIcon /> Novo Horário
              </Button>
            </Box>
          </Box>


          {/* Filtros movidos para o cabeçalho da tabela seguindo padrão do colaboradores */}
          {false && (
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              {/* Filtros de Texto */}
              <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                <TextField
                  label="Turma"
                  size="small"
                  value={filtros.nome}
                  onChange={(e) => setFiltros(prev => ({ ...prev, nome: e.target.value }))}
                  sx={{ flex: 1, minWidth: 200 }}
                  placeholder="Digite para filtrar..."
                />
                <FormControl size="small" sx={{ flex: 1, minWidth: 200 }}>
                  <InputLabel>Local</InputLabel>
                  <Select
                    value={filtros.local}
                    onChange={(e) => setFiltros(prev => ({ ...prev, local: e.target.value }))}
                    label="Local"
                  >
                    <MenuItem value="">Todos</MenuItem>
                    {locais.map(local => (
                      <MenuItem key={local.id} value={local.id}>{local.nome}</MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl size="small" sx={{ flex: 1, minWidth: 200 }}>
                  <InputLabel>Status</InputLabel>
                  <Select
                    value={filtros.status}
                    onChange={(e) => setFiltros(prev => ({ ...prev, status: e.target.value }))}
                    label="Status"
                  >
                    <MenuItem value="">Todos</MenuItem>
                    <MenuItem value="Em Andamento">Em Andamento</MenuItem>
                    <MenuItem value="Encerrada">Encerrada</MenuItem>
                    <MenuItem value="Breve">Breve</MenuItem>
                  </Select>
                </FormControl>
              </Box>

              {/* Filtros de Período */}
              <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }}>
                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
                  <DesktopDatePicker
                    label="Período Início"
                    value={filtros.periodoInicio ? new Date(filtros.periodoInicio) : null}
                    onChange={(data) => {
                      if (data) {
                        const dataFormatada = format(data, 'yyyy-MM-dd');
                        setFiltros(prev => ({ ...prev, periodoInicio: dataFormatada }));
                      } else {
                        setFiltros(prev => ({ ...prev, periodoInicio: '' }));
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        sx={{ flex: 1, minWidth: 150 }}
                      />
                    )}
                  />
                </LocalizationProvider>
                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
                  <DesktopDatePicker
                    label="Período Fim"
                    value={filtros.periodoFim ? new Date(filtros.periodoFim) : null}
                    onChange={(data) => {
                      if (data) {
                        const dataFormatada = format(data, 'yyyy-MM-dd');
                        setFiltros(prev => ({ ...prev, periodoFim: dataFormatada }));
                      } else {
                        setFiltros(prev => ({ ...prev, periodoFim: '' }));
                      }
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        size="small"
                        sx={{ flex: 1, minWidth: 150 }}
                      />
                    )}
                  />
                </LocalizationProvider>
                <FormControl size="small" sx={{ flex: 1, minWidth: 150 }}>
                  <InputLabel>Situação</InputLabel>
                  <Select
                    value={filtros.situacao}
                    onChange={(e) => setFiltros(prev => ({ ...prev, situacao: e.target.value }))}
                    label="Situação"
                  >
                    <MenuItem value="">Todas</MenuItem>
                    <MenuItem value="aberto">Aberto</MenuItem>
                    <MenuItem value="encerrado">Encerrado</MenuItem>
                    <MenuItem value="interesse">Interesse</MenuItem>
                    <MenuItem value="descontinuado">Descontinuado</MenuItem>
                  </Select>
                </FormControl>
                <FormControl size="small" sx={{ flex: 1, minWidth: 150 }}>
                  <InputLabel>Colaborador</InputLabel>
                  <Select
                    value={filtros.colaborador}
                    onChange={(e) => setFiltros(prev => ({ ...prev, colaborador: e.target.value }))}
                    label="Colaborador"
                  >
                    <MenuItem value="">Todos</MenuItem>
                    {colaboradores.map(colab => (
                      <MenuItem key={colab.id} value={colab.id}>
                        {colab.nome_completo || colab.nome}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <FormControl size="small" sx={{ flex: 1, minWidth: 150 }}>
                  <InputLabel>Serviço</InputLabel>
                  <Select
                    value={filtros.servico}
                    onChange={(e) => setFiltros(prev => ({ ...prev, servico: e.target.value }))}
                    label="Serviço"
                  >
                    <MenuItem value="">Todos</MenuItem>
                    {servicos.map(servico => (
                      <MenuItem key={servico.id} value={servico.id}>
                        <Box>
                          <Typography variant="body2" sx={{ fontWeight: 500 }}>
                            {servico.nome}
                          </Typography>
                          {servico.descricao && (
                            <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
                              {servico.descricao}
                            </Typography>
                          )}
                        </Box>
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>

              {/* Resumo dos Filtros */}
              {temFiltrosAtivos() && (
                <Box sx={{ 
                  backgroundColor: '#f5f5f5', 
                  p: 1, 
                  borderRadius: 1,
                  border: '1px solid #e0e0e0'
                }}>
                  <Typography variant="caption" color="text.secondary">
                    <strong>Filtros ativos:</strong> {Object.entries(filtros)
                      .filter(([key, value]) => value !== '')
                      .map(([key, value]) => {
                        let label = '';
                        switch (key) {
                          case 'nome': label = `Turma: "${value}"`; break;
                          case 'periodoInicio': label = `Período início: ${format(new Date(value), 'dd/MM/yyyy')}`; break;
                          case 'periodoFim': label = `Período fim: ${format(new Date(value), 'dd/MM/yyyy')}`; break;
                          case 'situacao': label = `Situação: ${value}`; break;
                          case 'status': label = `Status: ${value}`; break;
                          case 'local': 
                            const local = locais.find(l => l.id === Number(value));
                            label = `Local: ${local?.nome || value}`; 
                            break;
                          case 'colaborador':
                            const colab = colaboradores.find(c => c.id === Number(value));
                            label = `Colaborador: ${colab?.nome_completo || colab?.nome || value}`;
                            break;
                          case 'servico':
                            const serv = servicos.find(s => s.id === Number(value));
                            const servicoLabel = serv?.nome || value;
                            const servicoDesc = serv?.descricao ? ` (${serv.descricao})` : '';
                            label = `Serviço: ${servicoLabel}${servicoDesc}`;
                            break;
                          default: label = `${key}: ${value}`;
                        }
                        return label;
                      })
                      .join(', ')}
                  </Typography>
                  <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mt: 0.5 }}>
                    <strong>Resultados:</strong> {horariosFiltrados.length} de {horarios.length} horários encontrados
                    {horariosFiltrados.length !== horarios.length && (
                      <span style={{ color: '#2196f3', fontWeight: 'bold' }}>
                        {' '}({Math.round((horariosFiltrados.length / horarios.length) * 100)}% do total)
                      </span>
                    )}
                  </Typography>
                </Box>
              )}
            </Box>
          )}
        
        {horariosComConflito.length > 0 && (
          <Alert severity="warning" sx={{ mb: 2 }}>
            <Typography variant="body2">
              ⚠️ <strong>{horariosComConflito.length}</strong> horário(s) com conflito(s) detectado(s): 
              {horariosComConflito.map((h, index) => (
                <span key={h.id || h._id}>
                  {index > 0 ? ', ' : ' '}"<strong>{h.nome}</strong>"
                </span>
              ))}
            </Typography>
          </Alert>
        )}
        
          {/* Container da Tabela */}
          <TableContainer
            component={Paper}
            sx={{
              flex: 1,
              display: 'flex',
              flexDirection: 'column',
              position: 'relative',
              overflow: 'auto',
              height: {
                xs: 'calc(90vh - 140px)',
                sm: 'calc(90vh - 120px)',
                md: 'calc(90vh - 120px)',
                lg: 'calc(90vh - 120px)'
              },
              maxHeight: {
                xs: 'calc(90vh - 140px)',
                sm: 'calc(90vh - 120px)',
                md: 'calc(90vh - 120px)',
                lg: 'calc(90vh - 120px)'
              },
              width: '100%',
              minWidth: { xs: '100%', sm: '600px' },
              maxWidth: '100%',
              boxShadow: (theme) => theme.palette.mode === 'dark' ? '0 2px 8px rgba(0, 0, 0, 0.15)' : '0 2px 8px rgba(0, 0, 0, 0.06)',
              borderRadius: 2,
              border: 'none'
            }}
          >
            <Table sx={{ minWidth: '100%', tableLayout: 'fixed' }}>
            <TableHead sx={{
              position: 'sticky',
              top: 0,
              zIndex: 10,
              backgroundColor: (theme) => theme.palette.background.paper,
              '& .MuiTableCell-root': {
                backgroundColor: (theme) => theme.palette.background.paper,
                borderBottom: 2,
                borderBottomColor: 'divider'
              }
            }}>
              <TableRow>
                <TableCell sx={{ 
                  width: { xs: '15%', sm: '11%' },
                  minWidth: { xs: '120px', sm: '100px' }
                }}>
                  Código da Turma
                  <TextField
                    name="codigoTurma"
                    size="small"
                    fullWidth
                    value={filtros.codigoTurma || ''}
                    onChange={handleFiltroChange}
                    placeholder="Filtrar por código"
                    sx={{ 
                      '& .MuiInputBase-input': {
                        fontSize: { xs: '0.75rem', sm: '0.875rem' }
                      }
                    }}
                  />
                </TableCell>
                <TableCell sx={{ 
                  width: { xs: '20%', sm: '14%' },
                  minWidth: { xs: '150px', sm: '120px' }
                }}>
                  Nome
                  <TextField
                    name="nome"
                    size="small"
                    fullWidth
                    value={filtros.nome}
                    onChange={handleFiltroChange}
                    placeholder="Filtrar por nome"
                    sx={{ 
                      '& .MuiInputBase-input': {
                        fontSize: { xs: '0.75rem', sm: '0.875rem' }
                      }
                    }}
                  />
                </TableCell>
                <TableCell sx={{ 
                  width: { xs: '20%', sm: '14%' },
                  minWidth: { xs: '120px', sm: '100px' }
                }}>
                  Período
                </TableCell>
                <TableCell sx={{ 
                  width: { xs: '15%', sm: '12%' },
                  minWidth: { xs: '100px', sm: '80px' }
                }}>
                  Horário
                </TableCell>
                <TableCell sx={{ 
                  width: { xs: '20%', sm: '15%' },
                  minWidth: { xs: '120px', sm: '100px' }
                }}>
                  Local
                  <FormControl size="small" fullWidth>
                    <Select
                      name="local"
                      value={filtros.local}
                      onChange={handleFiltroChange}
                      displayEmpty
                      sx={{ 
                        '& .MuiInputBase-input': {
                          fontSize: { xs: '0.75rem', sm: '0.875rem' }
                        }
                      }}
                    >
                      <MenuItem value="">Todos</MenuItem>
                      {locais.map(local => (
                        <MenuItem key={local.id} value={local.id}>{local.nome}</MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </TableCell>
                <TableCell sx={{ 
                  width: { xs: '15%', sm: '11%' },
                  minWidth: { xs: '120px', sm: '100px' }
                }}>
                  Colaborador
                  <FormControl size="small" fullWidth>
                    <Select
                      name="colaborador"
                      value={filtros.colaborador}
                      onChange={handleFiltroChange}
                      displayEmpty
                      sx={{ 
                        '& .MuiInputBase-input': {
                          fontSize: { xs: '0.75rem', sm: '0.875rem' }
                        }
                      }}
                    >
                      <MenuItem value="">Todos</MenuItem>
                      {colaboradores.map(colab => (
                        <MenuItem key={colab.id} value={colab.id}>
                          {colab.nome_completo || colab.nome}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </TableCell>
                <TableCell sx={{ 
                  width: { xs: '12%', sm: '8%' },
                  minWidth: { xs: '100px', sm: '80px' }
                }}>
                  Situação
                  <FormControl size="small" fullWidth>
                    <Select
                      name="situacao"
                      value={filtros.situacao}
                      onChange={handleFiltroChange}
                      displayEmpty
                      sx={{ 
                        '& .MuiInputBase-input': {
                          fontSize: { xs: '0.75rem', sm: '0.875rem' }
                        }
                      }}
                    >
                      <MenuItem value="">Todas</MenuItem>
                      <MenuItem value="aberto">Aberto</MenuItem>
                      <MenuItem value="encerrado">Encerrado</MenuItem>
                      <MenuItem value="interesse">Interesse</MenuItem>
                      <MenuItem value="descontinuado">Descontinuado</MenuItem>
                    </Select>
                  </FormControl>
                </TableCell>
                <TableCell sx={{ 
                  width: { xs: '14%', sm: '10%' },
                  minWidth: { xs: '120px', sm: '100px' }
                }}>
                  Status
                  <FormControl size="small" fullWidth>
                    <Select
                      name="status"
                      value={filtros.status}
                      onChange={handleFiltroChange}
                      displayEmpty
                      sx={{ 
                        '& .MuiInputBase-input': {
                          fontSize: { xs: '0.75rem', sm: '0.875rem' }
                        }
                      }}
                    >
                      <MenuItem value="">Todos</MenuItem>
                      <MenuItem value="Em Andamento">Em Andamento</MenuItem>
                      <MenuItem value="Encerrada">Encerrada</MenuItem>
                      <MenuItem value="Breve">Breve</MenuItem>
                    </Select>
                  </FormControl>
                </TableCell>
                <TableCell sx={{ 
                  width: { xs: '15%', sm: '9%' },
                  minWidth: { xs: '120px', sm: '100px' }
                }}>
                  Ações
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow><TableCell colSpan={9} align="center"><CircularProgress /></TableCell></TableRow>
              ) : horarios.length === 0 ? (
                <TableRow><TableCell colSpan={9} align="center">Nenhum horário encontrado.</TableCell></TableRow>
              ) : horariosFiltrados.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={9} align="center">
                    <Box sx={{ py: 2 }}>
                      <Typography variant="body2" color="text.secondary" gutterBottom>
                        {temFiltrosAtivos() 
                          ? "Nenhum horário encontrado com os filtros aplicados."
                          : "Nenhum horário encontrado."
                        }
                      </Typography>
                      {temFiltrosAtivos() && (
                        <Button
                          size="small"
                          variant="outlined"
                          onClick={limparFiltros}
                          sx={{ mt: 1 }}
                        >
                          Limpar Filtros
                        </Button>
                      )}
                    </Box>
                  </TableCell>
                </TableRow>
              ) : (
                horariosFiltrados.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((horario, index) => {
                  // Calcular horário de fim baseado na duração
                  const calcularHorarioFim = (horaInicio, duracaoMinutos) => {
                    const [horas, minutos] = horaInicio.split(':').map(Number);
                    const data = new Date();
                    data.setHours(horas);
                    data.setMinutes(minutos);
                    data.setMinutes(data.getMinutes() + duracaoMinutos);
                    return `${String(data.getHours()).padStart(2, '0')}:${String(data.getMinutes()).padStart(2, '0')}`;
                  };
                  
                  const horarioFim = calcularHorarioFim(horario.horaInicio, horario.duracao_minuto);
                  const localNome = locais.find(l => l.id === horario.local)?.nome || horario.local;
                  const temSobreposicao = verificarSobreposicao(horario, horariosOrdenados);
                  const status = calcularStatus(horario.diaInicio, horario.diaFim);
                  const rowKey = horario.id || horario._id || `${horario.codigoTurma || 'horario'}-${index}`;
                  
                  return (
                    <TableRow 
                      key={rowKey}
                      sx={{
                        backgroundColor: temSobreposicao 
                          ? '#ffebee' 
                          : index % 2 === 0 
                            ? (theme) => theme.palette.mode === 'dark' 
                              ? 'rgba(255, 255, 255, 0.02)' 
                              : 'rgba(0, 0, 0, 0.02)'
                            : 'transparent',
                        borderLeft: temSobreposicao ? '4px solid #f44336' : 'none',
                        '&:hover': {
                          backgroundColor: temSobreposicao 
                            ? '#ffcdd2' 
                            : (theme) => theme.palette.mode === 'dark' 
                              ? 'rgba(255, 255, 255, 0.08)' 
                              : 'rgba(0, 0, 0, 0.08)'
                        }
                      }}
                    >
                      <TableCell sx={{ 
                        color: temSobreposicao ? '#d32f2f' : 'inherit', 
                        fontWeight: temSobreposicao ? 'bold' : 'normal',
                        backgroundColor: temSobreposicao ? '#ffebee' : 'inherit',
                        fontSize: '0.875rem',
                        lineHeight: 1.2
                      }}>
                        {horario.codigoTurma}
                      </TableCell>
                      <TableCell sx={{ 
                        color: temSobreposicao ? '#d32f2f' : 'inherit', 
                        fontWeight: temSobreposicao ? 'bold' : 'normal',
                        backgroundColor: temSobreposicao ? '#ffebee' : 'inherit',
                        fontSize: '0.875rem',
                        lineHeight: 1.2
                      }}>
                        {horario.nome}
                        {temSobreposicao && <span style={{ color: '#f44336', marginLeft: '8px' }}>⚠️ CONFLITO</span>}
                      </TableCell>
                      <TableCell sx={{ 
                        color: temSobreposicao ? '#d32f2f' : 'inherit',
                        backgroundColor: temSobreposicao ? '#ffebee' : 'inherit',
                        fontSize: '0.875rem'
                      }}>
                        {`${format(parseISO(horario.diaInicio), 'dd/MM/yyyy')} - ${format(parseISO(horario.diaFim), 'dd/MM/yyyy')}`}
                      </TableCell>
                      <TableCell sx={{ 
                        color: temSobreposicao ? '#d32f2f' : 'inherit',
                        backgroundColor: temSobreposicao ? '#ffebee' : 'inherit',
                        fontSize: '0.875rem'
                      }}>
                        {`${horario.horaInicio} - ${horarioFim} (${horario.duracao_minuto} min)`}
                      </TableCell>
                      <TableCell sx={{ 
                        color: temSobreposicao ? '#d32f2f' : 'inherit',
                        backgroundColor: temSobreposicao ? '#ffebee' : 'inherit',
                        fontSize: '0.875rem'
                      }}>
                        {`${localNome} (max. ${horario.numeroMaximoClientes})`}
                      </TableCell>
                      <TableCell sx={{ 
                        color: temSobreposicao ? '#d32f2f' : 'inherit',
                        backgroundColor: temSobreposicao ? '#ffebee' : 'inherit',
                        fontSize: '0.875rem'
                      }}>
                        {colaboradores.find(c => c.id === horario.colaborador)?.nome_completo || horario.colaborador}
                      </TableCell>
                      <TableCell sx={{ 
                        color: temSobreposicao ? '#d32f2f' : 'inherit',
                        backgroundColor: temSobreposicao ? '#ffebee' : 'inherit',
                        fontSize: '0.875rem'
                      }}>
                        <span style={{
                          background: horario.situacao === 'aberto' ? '#e8f5e8' : 
                                     horario.situacao === 'encerrado' ? '#ffebee' : 
                                     horario.situacao === 'interesse' ? '#fff3e0' : 
                                     horario.situacao === 'descontinuado' ? '#f3e5f5' : 
                                     '#e3f2fd',
                          color: horario.situacao === 'aberto' ? '#2e7d32' : 
                                 horario.situacao === 'encerrado' ? '#d32f2f' : 
                                 horario.situacao === 'interesse' ? '#f57c00' : 
                                 horario.situacao === 'descontinuado' ? '#7b1fa2' : 
                                 '#1976d2',
                          padding: '4px 8px',
                          borderRadius: '12px',
                          fontSize: '0.75rem',
                          fontWeight: 'bold',
                          display: 'inline-flex',
                          alignItems: 'center',
                          gap: '4px',
                          border: `1px solid ${horario.situacao === 'aberto' ? '#4caf50' : 
                                                   horario.situacao === 'encerrado' ? '#f44336' : 
                                                   horario.situacao === 'interesse' ? '#ff9800' : 
                                                   horario.situacao === 'descontinuado' ? '#9c27b0' : 
                                                   '#2196f3'}`,
                          position: 'relative'
                        }}>
                          {horario.situacao === 'aberto' && (
                            <ThumbUpIcon sx={{ 
                              fontSize: '0.75rem',
                              animation: 'pulse 1.5s infinite'
                            }} />
                          )}
                          {horario.situacao === 'encerrado' && <BlockIcon sx={{ fontSize: '0.75rem' }} />}
                          {horario.situacao === 'interesse' && <LightbulbIcon sx={{ fontSize: '0.75rem' }} />}
                          {horario.situacao === 'descontinuado' && <ThumbDownIcon sx={{ fontSize: '0.75rem' }} />}
                          {horario.situacao === 'aberto' && 'Aberto'}
                          {horario.situacao === 'encerrado' && 'Encerrado'}
                          {horario.situacao === 'interesse' && 'Interesse'}
                          {horario.situacao === 'descontinuado' && 'Descontinuado'}
                        </span>
                      </TableCell>
                      <TableCell sx={{ 
                        color: temSobreposicao ? '#d32f2f' : 'inherit',
                        backgroundColor: temSobreposicao ? '#ffebee' : 'inherit',
                        fontSize: '0.875rem'
                      }}>
                        <span style={{
                          background: status === 'Em Andamento' ? '#e3f2fd' : 
                                     status === 'Encerrada' ? '#ffebee' : 
                                     status === 'Breve' ? '#fff3e0' :
                                     '#e8f5e8',
                          color: status === 'Em Andamento' ? '#1976d2' : 
                                 status === 'Encerrada' ? '#d32f2f' : 
                                 status === 'Breve' ? '#f57c00' :
                                 '#2e7d32',
                          padding: '4px 8px',
                          borderRadius: '12px',
                          fontSize: '0.75rem',
                          fontWeight: 'bold',
                          display: 'inline-flex',
                          alignItems: 'center',
                          gap: '4px',
                          border: `1px solid ${status === 'Em Andamento' ? '#2196f3' : 
                                                   status === 'Encerrada' ? '#f44336' : 
                                                   status === 'Breve' ? '#ff9800' :
                                                   '#4caf50'}`
                        }}>
                          {status === 'Em Andamento' && <TrafficIcon sx={{ fontSize: '0.75rem' }} />}
                          {status === 'Encerrada' && <SchoolIcon sx={{ fontSize: '0.75rem' }} />}
                          {status === 'Breve' && <SunIcon sx={{ fontSize: '0.75rem' }} />}
                          {status === 'Em Andamento' && 'Em Andamento'}
                          {status === 'Encerrada' && 'Encerrada'}
                          {status === 'Breve' && 'Em Breve'}
                        </span>
                      </TableCell>
                      <TableCell sx={{ fontSize: '0.875rem' }}>
                                              <IconButton size="small" onClick={() => handleOpenView(horario)} title="Visualizar"><VisibilityIcon fontSize="small" className="material-icon-visibility" /></IconButton>
                      <IconButton size="small" onClick={() => handleOpenForm(horario)} title="Editar"><EditIcon fontSize="small" className="material-icon-edit" /></IconButton>
                      <IconButton size="small" onClick={() => handleExcluir(horario)} title="Excluir"><DeleteIcon fontSize="small" className="material-icon-delete" /></IconButton>
                      </TableCell>
                    </TableRow>
                  );
                })
              )}
            </TableBody>
          </Table>
        </TableContainer>
          {/* Paginação fora do TableContainer */}
          <TablePagination
            component="div"
            count={horariosFiltrados.length}
            page={page}
            onPageChange={(e, newPage) => setPage(newPage)}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={e => { setRowsPerPage(parseInt(e.target.value, 10)); setPage(0); }}
            rowsPerPageOptions={[5, 10, 25]}
            labelRowsPerPage="Itens por página"
            labelDisplayedRows={({ from, to, count }) => `${from}-${to} de ${count}`}
            sx={{
              backgroundColor: (theme) => theme.palette.background.default,
              borderTop: 'none',
              width: '100%',
              marginTop: 0
            }}
          />
        </Box> {/* Fechamento do Box interno com margens */}
        {/* Formulário */}
        <Dialog 
          open={openForm} 
          onClose={handleCloseForm} 
          maxWidth="md" 
          fullWidth
          disableEscapeKeyDown
          disableBackdropClick
          disablePortal
          hideBackdrop={false}
          sx={{
            '& .MuiDialog-backdrop': {
              backgroundColor: 'rgba(0, 0, 0, 0.8)'
            }
          }}
          PaperProps={{
            sx: {
              maxHeight: '90vh',
              overflowY: 'auto'
            }
          }}
        >
          <DialogTitle sx={{ 
            backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#1B5E20' : '#E0F8E0',
            borderBottom: 1,
            borderColor: 'divider',
            padding: 2,
            position: 'sticky',
            top: 0,
            zIndex: 1,
            fontSize: '1.25rem',
            fontWeight: 500
          }}>
            {horarioSelecionado ? "Editar Horário" : "Novo Horário"}
          </DialogTitle>
          <DialogContent sx={{ 
            height: 'calc(100% - 140px)',
            overflow: 'auto',
            padding: 2,
            '&.MuiDialogContent-root': {
              paddingTop: 2
            },
            position: 'relative',
            top: 0,
            marginBottom: '60px',
            '& .MuiInputLabel-root': {
              fontSize: '0.875rem'
            },
            '& .MuiInputBase-input': {
              fontSize: '0.875rem'
            },
            '& .MuiFormControlLabel-label': {
              fontSize: '0.875rem'
            },
            '& .MuiTabs-root': {
              borderBottom: 1,
              borderColor: 'divider'
            },
            '& .MuiTab-root': {
              fontSize: '0.875rem',
              textTransform: 'none',
              minWidth: 120
            }
          }}>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Box sx={{ display: 'flex', gap: 2 }}>
                <TextField 
                  label="Código da Turma" 
                  name="codigoTurma" 
                  value={formData.codigoTurma} 
                  InputProps={{ readOnly: true }}
                  sx={{ 
                    width: '50%',
                    '& .MuiInputBase-input': {
                      backgroundColor: '#f5f5f5',
                      color: '#666'
                    }
                  }}
                  helperText="Gerado automaticamente"
                />
                <FormControl sx={{ width: '50%' }} error={formErrors.situacao} required>
                  <InputLabel>Situação</InputLabel>
                  <Select name="situacao" value={formData.situacao} onChange={e => setFormData({ ...formData, situacao: e.target.value })} label="Situação">
                    <MenuItem value="aberto">Aberto</MenuItem>
                    <MenuItem value="encerrado">Encerrado</MenuItem>
                    <MenuItem value="interesse">Interesse</MenuItem>
                    <MenuItem value="descontinuado">Descontinuado</MenuItem>
                  </Select>
                </FormControl>
              </Box>
              <TextField label="Nome" name="nome" value={formData.nome} onChange={e => setFormData({ ...formData, nome: e.target.value })} error={formErrors.nome} fullWidth required />
              <Box sx={{ display: 'flex', gap: 2 }}>
                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
                  <DesktopDatePicker
                    label="Data Início"
                    value={formData.diaInicio ? new Date(formData.diaInicio.split('/').reverse().join('-')) : null}
                    onChange={(data) => {
                      if (data) {
                        const dataFormatada = format(data, 'dd/MM/yyyy');
                        setFormData(prev => ({ 
                          ...prev, 
                          diaInicio: dataFormatada 
                        }));
                        if (formData.diaFim) {
                          const dataFim = new Date(formData.diaFim.split('/').reverse().join('-'));
                          if (data > dataFim) {
                            setFormData(prev => ({ ...prev, diaFim: '' }));
                            setFormErrors(prev => ({ ...prev, diaFim: true }));
                          }
                        }
                        setFormErrors(prev => ({ ...prev, diaInicio: false }));
                      }
                    }}
                    shouldDisableDate={(date) => {
                      const hoje = new Date();
                      hoje.setHours(0, 0, 0, 0);
                      return date < hoje;
                    }}
                    disabled={!isFieldEnabled('diaInicio')}
                    renderInput={(params) => (
                      <TextField 
                        {...params} 
                        error={formErrors.diaInicio}
                        helperText={formErrors.diaInicio ? "Data não pode ser menor que hoje" : !isFieldEnabled('diaInicio') ? getDisabledFieldHelperText('diaInicio') : "Selecione a data de início"}
                        placeholder="DD/MM/AAAA"
                        InputLabelProps={{ shrink: true }}
                        inputProps={{
                          ...params.inputProps,
                          readOnly: true,
                          style: { fontSize: '0.875rem', color: '#222' }
                        }}
                        sx={{ 
                          width: '33%', 
                          '& .MuiInputBase-input': { 
                            fontSize: '0.875rem', 
                            color: '#222',
                            backgroundColor: !isFieldEnabled('diaInicio') ? '#f5f5f5' : '#fff'
                          }, 
                          '& .MuiInputLabel-root': { 
                            fontSize: '0.875rem', 
                            color: !isFieldEnabled('diaInicio') ? '#999' : '#222'
                          } 
                        }}
                        required
                      />
                    )}
                  />
                </LocalizationProvider>
                <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR}>
                  <DesktopDatePicker
                    label="Data Fim"
                    value={formData.diaFim ? new Date(formData.diaFim.split('/').reverse().join('-')) : null}
                    onChange={(data) => {
                      if (data) {
                        const dataFormatada = format(data, 'dd/MM/yyyy');
                        setFormData(prev => ({ 
                          ...prev, 
                          diaFim: dataFormatada 
                        }));
                        setFormErrors(prev => ({ ...prev, diaFim: false }));
                      }
                    }}
                    shouldDisableDate={(date) => {
                      const hoje = new Date();
                      hoje.setHours(0, 0, 0, 0);
                      if (date < hoje) return true;
                      if (formData.diaInicio) {
                        const dataInicio = new Date(formData.diaInicio.split('/').reverse().join('-'));
                        return date < dataInicio;
                      }
                      return false;
                    }}
                    disabled={!isFieldEnabled('diaFim')}
                    renderInput={(params) => (
                      <TextField 
                        {...params} 
                        error={formErrors.diaFim}
                        helperText={formErrors.diaFim ? "Data não pode ser menor que o dia início" : !isFieldEnabled('diaFim') ? getDisabledFieldHelperText('diaFim') : "Selecione a data de fim"}
                        placeholder="DD/MM/AAAA"
                        InputLabelProps={{ shrink: true }}
                        inputProps={{
                          ...params.inputProps,
                          readOnly: true,
                          style: { fontSize: '0.875rem', color: '#222' }
                        }}
                        sx={{ 
                          width: '33%', 
                          '& .MuiInputBase-input': { 
                            fontSize: '0.875rem', 
                            color: '#222',
                            backgroundColor: !isFieldEnabled('diaFim') ? '#f5f5f5' : '#fff'
                          }, 
                          '& .MuiInputLabel-root': { 
                            fontSize: '0.875rem', 
                            color: !isFieldEnabled('diaFim') ? '#999' : '#222'
                          } 
                        }}
                        required
                      />
                    )}
                  />
                </LocalizationProvider>
                <TextField 
                  label="Duração (min)" 
                  name="duracao_minuto" 
                  type="number" 
                  value={formData.duracao_minuto} 
                  onChange={e => {
                    const novaDuracao = e.target.value;
                    const horaFimCalculada = calcularHoraFim(formData.horaInicio, novaDuracao);
                    setFormData({ 
                      ...formData, 
                      duracao_minuto: novaDuracao,
                      horaFim: horaFimCalculada
                    });
                  }} 
                  error={formErrors.duracao_minuto} 
                  helperText={formErrors.duracao_minuto ? "Duração é obrigatória" : !isFieldEnabled('duracao_minuto') ? getDisabledFieldHelperText('duracao_minuto') : "Ex: 60"}
                  sx={{ 
                    width: '33%',
                    '& .MuiInputBase-input': {
                      backgroundColor: !isFieldEnabled('duracao_minuto') ? '#f5f5f5' : '#fff',
                      color: !isFieldEnabled('duracao_minuto') ? '#999' : '#222'
                    },
                    '& .MuiInputLabel-root': {
                      color: !isFieldEnabled('duracao_minuto') ? '#999' : '#222'
                    }
                  }} 
                  disabled={!isFieldEnabled('duracao_minuto')}
                  required 
                />
              </Box>
              <Box sx={{ display: 'flex', gap: 2, width: '100%' }}>
                <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1, flex: 1 }}>
                  <Typography component="span" sx={{ 
                    color: !isFieldEnabled('diasSelecionados') ? '#999' : 'error.main', 
                    fontSize: '0.875rem'
                  }}>
                    Dias da Semana (Obrigatório)
                  </Typography>
                  <Box sx={{ 
                    display: 'flex', 
                    flexWrap: 'wrap', 
                    gap: 1,
                    opacity: !isFieldEnabled('diasSelecionados') ? 0.5 : 1,
                    pointerEvents: !isFieldEnabled('diasSelecionados') ? 'none' : 'auto',
                    '& .dia-button': {
                      minWidth: '45px',
                      height: '28px',
                      borderRadius: '14px',
                      border: '2px solid #e0e0e0',
                      backgroundColor: '#ffffff',
                      color: '#222',
                      fontSize: '0.875rem',
                      fontWeight: 'bold',
                      textTransform: 'uppercase',
                      transition: 'all 0.3s ease',
                      cursor: !isFieldEnabled('diasSelecionados') ? 'not-allowed' : 'pointer',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      '&:hover': {
                        transform: !isFieldEnabled('diasSelecionados') ? 'none' : 'translateY(-2px)',
                        boxShadow: !isFieldEnabled('diasSelecionados') ? 'none' : '0 4px 8px rgba(0,0,0,0.1)',
                        borderColor: !isFieldEnabled('diasSelecionados') ? '#e0e0e0' : '#2196f3',
                        color: !isFieldEnabled('diasSelecionados') ? '#999' : '#2196f3'
                      },
                      '&.selected': {
                        backgroundColor: '#2196f3',
                        color: '#ffffff',
                        borderColor: '#2196f3',
                        boxShadow: '0 4px 12px rgba(33, 150, 243, 0.3)',
                        transform: 'translateY(-2px)',
                        animation: 'pulse 0.6s ease-in-out'
                      }
                    }
                  }}>
                    {Object.entries(diasSemana).map(([dia, nome]) => {
                      const isSelected = formData.diasSelecionados && formData.diasSelecionados.includes(parseInt(dia));
                      return (
                        <Box
                          key={dia}
                          className={`dia-button ${isSelected ? 'selected' : ''}`}
                          onClick={() => {
                            if (!isFieldEnabled('diasSelecionados')) return;
                            const newValue = isSelected 
                              ? (formData.diasSelecionados || []).filter(d => d !== parseInt(dia))
                              : [...(formData.diasSelecionados || []), parseInt(dia)];
                            setFormData({ ...formData, diasSelecionados: newValue });
                          }}
                          sx={{
                            '&:active': {
                              transform: !isFieldEnabled('diasSelecionados') ? 'none' : 'translateY(0px) scale(0.95)'
                            },
                            fontSize: '0.875rem',
                            color: !isFieldEnabled('diasSelecionados') ? '#999' : '#222',
                            fontWeight: 'bold',
                            backgroundColor: isSelected ? '#2196f3' : !isFieldEnabled('diasSelecionados') ? '#f5f5f5' : '#fff',
                            borderColor: isSelected ? '#2196f3' : !isFieldEnabled('diasSelecionados') ? '#e0e0e0' : '#e0e0e0',
                          }}
                        >
                          {nome.substring(0, 3)}
                        </Box>
                      );
                    })}
                  </Box>
                  {formErrors.diasSelecionados && (
                    <Typography variant="caption" color="error" sx={{ mt: 0.5 }}>
                      Selecione pelo menos um dia da semana
                    </Typography>
                  )}
                  {!isFieldEnabled('diasSelecionados') && !formErrors.diasSelecionados && (
                    <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }}>
                      {getDisabledFieldHelperText('diasSelecionados')}
                    </Typography>
                  )}
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', minWidth: '200px' }}>
                  <TextField 
                    label={
                      <Typography component="span" sx={{ color: !isFieldEnabled('horaInicio') ? '#999' : 'error.main' }}>
                        Hora Início
                      </Typography>
                    }
                    name="horaInicio" 
                    type="time" 
                    value={formData.horaInicio} 
                    onChange={e => {
                      const novaHoraInicio = e.target.value;
                      const horaFimCalculada = calcularHoraFim(novaHoraInicio, formData.duracao_minuto);
                      setFormData({ 
                        ...formData, 
                        horaInicio: novaHoraInicio,
                        horaFim: horaFimCalculada
                      });
                    }} 
                    error={formErrors.horaInicio} 
                    helperText={formErrors.horaInicio ? "Hora de início é obrigatória" : !isFieldEnabled('horaInicio') ? getDisabledFieldHelperText('horaInicio') : "Ex: 09:00"}
                    InputLabelProps={{ shrink: true }}
                    disabled={!isFieldEnabled('horaInicio')}
                    inputProps={{
                      step: 300, // 5 minutos em segundos
                      format: '24h'
                    }}
                    sx={{
                      '& .MuiInputBase-input': {
                        backgroundColor: !isFieldEnabled('horaInicio') ? '#f5f5f5' : '#fff',
                        color: !isFieldEnabled('horaInicio') ? '#999' : '#222'
                      },
                      '& .MuiInputLabel-root': {
                        color: !isFieldEnabled('horaInicio') ? '#999' : '#222'
                      }
                    }}
                    required 
                  />
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', justifyContent: 'flex-end', minWidth: '200px' }}>
                  <TextField 
                    label="Hora Fim" 
                    name="horaFim" 
                    type="time" 
                    value={formData.horaFim} 
                    InputProps={{
                      readOnly: true,
                      style: { backgroundColor: '#f5f5f5' },
                      inputProps: {
                        step: 300, // 5 minutos em segundos
                        format: '24h'
                      }
                    }}
                    helperText="Calculado automaticamente"
                    InputLabelProps={{ shrink: true }}
                  />
                </Box>
              </Box>
              <Box sx={{ display: 'flex', gap: 2 }}>
                <FormControl fullWidth error={formErrors.local} required>
                  <InputLabel sx={{ color: !isFieldEnabled('local') ? '#999' : '#222' }}>Local</InputLabel>
                  <Select 
                    name="local" 
                    value={formData.local} 
                    onChange={e => {
                      const localSelecionado = locais.find(l => l.id === e.target.value);
                      setFormData({ 
                        ...formData, 
                        local: e.target.value,
                        capacidade: localSelecionado ? localSelecionado.capacidade || '' : '',
                        andar: localSelecionado ? localSelecionado.andar || '' : '',
                        bloco: localSelecionado ? localSelecionado.bloco || '' : ''
                      });
                    }} 
                    label="Local"
                    disabled={!isFieldEnabled('local')}
                    sx={{
                      '& .MuiInputBase-input': {
                        backgroundColor: !isFieldEnabled('local') ? '#f5f5f5' : '#fff',
                        color: !isFieldEnabled('local') ? '#999' : '#222'
                      }
                    }}
                  >
                    {!isFieldEnabled('local') ? (
                      <MenuItem disabled>
                        {getDisabledFieldHelperText('local')}
                      </MenuItem>
                    ) : (
                      locais.map(local => (
                        <MenuItem key={local.id} value={local.id}>{local.nome}</MenuItem>
                      ))
                    )}
                  </Select>
                  {!isFieldEnabled('local') && !formErrors.local && (
                    <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }}>
                      {getDisabledFieldHelperText('local')}
                    </Typography>
                  )}
                </FormControl>
              </Box>
              <Box sx={{ display: 'flex', gap: 2 }}>
                <TextField 
                  label="Capacidade" 
                  name="capacidade" 
                  value={formData.capacidade} 
                  onChange={e => setFormData({ ...formData, capacidade: e.target.value })} 
                  helperText="Preenchido automaticamente pelo local"
                  sx={{ width: '33%' }} 
                  InputProps={{
                    readOnly: true,
                    style: { backgroundColor: '#f5f5f5' }
                  }}
                />
                <TextField 
                  label="Andar" 
                  name="andar" 
                  value={formData.andar} 
                  onChange={e => setFormData({ ...formData, andar: e.target.value })} 
                  helperText="Preenchido automaticamente pelo local"
                  sx={{ width: '33%' }} 
                  InputProps={{
                    readOnly: true,
                    style: { backgroundColor: '#f5f5f5' }
                  }}
                />
                <TextField 
                  label="Bloco" 
                  name="bloco" 
                  value={formData.bloco} 
                  onChange={e => setFormData({ ...formData, bloco: e.target.value })} 
                  helperText="Preenchido automaticamente pelo local"
                  sx={{ width: '33%' }} 
                  InputProps={{
                    readOnly: true,
                    style: { backgroundColor: '#f5f5f5' }
                  }}
                />
              </Box>
              <Box sx={{ display: 'flex', gap: 2 }}>
                <TextField 
                  label="Número Máximo de Participantes" 
                  name="numeroMaximoClientes" 
                  type="number" 
                  value={formData.numeroMaximoClientes} 
                  onChange={e => setFormData({ ...formData, numeroMaximoClientes: Number(e.target.value) })} 
                  error={formErrors.numeroMaximoClientes}
                  helperText={formErrors.numeroMaximoClientes ? "Número máximo de participantes é obrigatório" : !isFieldEnabled('numeroMaximoClientes') ? getDisabledFieldHelperText('numeroMaximoClientes') : "Quantidade máxima de participantes por horário"}
                  sx={{ 
                    width: '50%',
                    '& .MuiInputBase-input': {
                      backgroundColor: !isFieldEnabled('numeroMaximoClientes') ? '#f5f5f5' : '#fff',
                      color: !isFieldEnabled('numeroMaximoClientes') ? '#999' : '#222'
                    },
                    '& .MuiInputLabel-root': {
                      color: !isFieldEnabled('numeroMaximoClientes') ? '#999' : '#222'
                    }
                  }} 
                  inputProps={{ min: 1, max: 100 }}
                  disabled={!isFieldEnabled('numeroMaximoClientes')}
                  required
                />
                <FormControl sx={{ width: '50%' }} error={formErrors.servico} required>
                  <InputLabel>Serviço</InputLabel>
                  <Select 
                    name="servico" 
                    value={formData.servico} 
                    onChange={e => {
                      setFormData({ ...formData, servico: e.target.value });
                    }} 
                    label="Serviço"
                    disabled={!isFieldEnabled('servico')}
                    sx={{
                      '& .MuiInputBase-input': {
                        backgroundColor: !isFieldEnabled('servico') ? '#f5f5f5' : '#fff',
                        color: !isFieldEnabled('servico') ? '#999' : '#222'
                      }
                    }}
                  >
                    {!isFieldEnabled('servico') ? (
                      <MenuItem disabled>
                        {getDisabledFieldHelperText('servico')}
                      </MenuItem>
                    ) : (
                      servicos.map(servico => (
                        <MenuItem key={servico.id} value={servico.id}>
                          <Box>
                            <Typography variant="body2" sx={{ fontWeight: 500 }}>
                              {servico.nome}
                            </Typography>
                            {servico.descricao && (
                              <Typography variant="caption" color="text.secondary" sx={{ display: 'block' }}>
                                {servico.descricao}
                              </Typography>
                            )}
                          </Box>
                        </MenuItem>
                      ))
                    )}
                  </Select>
                  {!isFieldEnabled('servico') && !formErrors.servico && (
                    <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5 }}>
                      {getDisabledFieldHelperText('servico')}
                    </Typography>
                  )}
                </FormControl>
              </Box>
              <Box sx={{ display: 'flex', gap: 2 }}>
                <FormControl fullWidth error={formErrors.colaborador} required>
                  <InputLabel sx={{ color: !isFieldEnabled('colaborador') ? '#999' : '#222' }}>Colaborador</InputLabel>
                  <Select 
                    name="colaborador" 
                    value={formData.colaborador} 
                    onChange={e => {
                      const colaboradorSelecionado = colaboradoresDisponiveis.find(c => c.id === e.target.value);
                      setFormData({ 
                        ...formData, 
                        colaborador: e.target.value,
                        colaboradorCargo: colaboradorSelecionado ? colaboradorSelecionado.cargo || '' : '',
                        colaboradorDepartamento: colaboradorSelecionado ? colaboradorSelecionado.departamento || '' : ''
                      });
                    }} 
                    label="Colaborador"
                    disabled={!isFieldEnabled('colaborador')}
                    endAdornment={loadingDisponibilidade ? <CircularProgress size={20} /> : null}
                    sx={{
                      '& .MuiInputBase-input': {
                        backgroundColor: !isFieldEnabled('colaborador') ? '#f5f5f5' : '#fff',
                        color: !isFieldEnabled('colaborador') ? '#999' : '#222'
                      }
                    }}
                  >
                    {loadingDisponibilidade ? (
                      <MenuItem disabled>
                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                          <CircularProgress size={16} />
                          Verificando disponibilidade individual...
                        </Box>
                      </MenuItem>
                    ) : colaboradoresDisponiveis.length === 0 ? (
                      <MenuItem disabled>
                        {!isFieldEnabled('colaborador') 
                          ? getDisabledFieldHelperText('colaborador')
                          : "Nenhum colaborador tem disponibilidade nos dias e horários selecionados"}
                      </MenuItem>
                    ) : (
                      colaboradoresDisponiveis.map(colab => (
                        <MenuItem key={colab.id} value={colab.id}>
                          {colab.nome_completo || colab.nome}
                        </MenuItem>
                      ))
                    )}
                  </Select>
                  <Typography variant="caption" color="text.secondary" sx={{ mt: 0.5, display: 'block' }}>
                    {!isFieldEnabled('colaborador')
                      ? `ℹ️ ${getDisabledFieldHelperText('colaborador')}`
                      : loadingDisponibilidade 
                        ? "⏳ Verificando disponibilidade individual de cada colaborador..."
                        : colaboradoresDisponiveis.length > 0
                          ? `✅ ${colaboradoresDisponiveis.length} colaborador(es) disponível(is) para o serviço, dias e horários selecionados`
                          : "⚠️ Nenhum colaborador tem disponibilidade para o serviço, dias e horários selecionados"}
                  </Typography>
                </FormControl>
              </Box>
              <Box sx={{ display: 'flex', gap: 2 }}>
                <TextField 
                  label="Cargo do Colaborador" 
                  name="colaboradorCargo" 
                  value={formData.colaboradorCargo} 
                  onChange={e => setFormData({ ...formData, colaboradorCargo: e.target.value })} 
                  error={formErrors.colaboradorCargo} 
                  helperText={formErrors.colaboradorCargo ? "Cargo é obrigatório" : "Preenchido automaticamente pelo colaborador"}
                  sx={{ width: '50%' }} 
                  required 
                  InputProps={{
                    readOnly: true,
                    style: { backgroundColor: '#f5f5f5' }
                  }}
                />
                <TextField 
                  label="Departamento do Colaborador" 
                  name="colaboradorDepartamento" 
                  value={formData.colaboradorDepartamento} 
                  onChange={e => setFormData({ ...formData, colaboradorDepartamento: e.target.value })} 
                  error={formErrors.colaboradorDepartamento} 
                  helperText={formErrors.colaboradorDepartamento ? "Departamento é obrigatório" : "Preenchido automaticamente pelo colaborador"}
                  sx={{ width: '50%' }} 
                  required 
                  InputProps={{
                    readOnly: true,
                    style: { backgroundColor: '#f5f5f5' }
                  }}
                />
              </Box>
            </Box>
          </DialogContent>
          <DialogActions sx={{ 
            position: 'absolute',
            bottom: 0,
            left: 0,
            right: 0,
            padding: 2,
            backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#1B5E20' : '#E0F8E0',
            borderTop: 1,
            borderColor: 'divider',
            zIndex: 1,
            height: '60px',
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            '& .MuiButton-root': {
              fontSize: '0.875rem',
              textTransform: 'uppercase',
              fontWeight: 500
            },
            '& .MuiTypography-root': {
              fontSize: '0.875rem'
            }
          }}>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
              <Typography variant="body2" color="text.secondary">
                {new Date().toLocaleString('pt-BR', {
                  day: '2-digit',
                  month: '2-digit',
                  year: 'numeric',
                  hour: '2-digit',
                  minute: '2-digit'
                })}
              </Typography>
              {error && (
                <Alert severity="error" sx={{ mb: 0 }}>
                  {error}
                </Alert>
              )}
              {success && (
                <Alert severity="success" sx={{ mb: 0 }}>
                  {success}
                </Alert>
              )}
            </Box>
            <Box sx={{ display: 'flex', gap: 1 }}>
              <Button 
                variant="contained" 
                color="primary"
                onClick={handleCloseForm}
              >
                FECHAR
              </Button>
              <Button 
                variant="contained" 
                color="primary"
                onClick={handleSalvar} 
                disabled={loading}
              >
                {loading ? <CircularProgress size={24} /> : "SALVAR"}
              </Button>
            </Box>
          </DialogActions>
        </Dialog>

        {/* Modal de Visualização */}
        <Dialog 
          open={openView} 
          onClose={handleCloseView} 
          maxWidth="md" 
          fullWidth
          sx={{
            '& .MuiDialog-backdrop': {
              backgroundColor: 'rgba(0, 0, 0, 0.8)'
            }
          }}
          PaperProps={{
            sx: {
              maxHeight: '90vh',
              overflowY: 'auto'
            }
          }}
        >
          <DialogTitle sx={{ 
            backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#1976d2' : '#E3F2FD',
            borderBottom: 1,
            borderColor: 'divider',
            padding: 2,
            fontSize: '1.25rem',
            fontWeight: 500
          }}>
            Visualizar Horário
          </DialogTitle>
          <DialogContent sx={{ 
            padding: 3,
            '& .MuiTypography-root': {
              fontSize: '0.875rem'
            }
          }}>
            {horarioParaVisualizar && (
              <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                <Box sx={{ display: 'flex', gap: 2 }}>
                  <TextField 
                    label="Código da Turma" 
                    value={horarioParaVisualizar.codigoTurma || 'N/A'} 
                    InputProps={{ readOnly: true }}
                    sx={{ width: '50%' }}
                  />
                  <TextField 
                    label="Situação" 
                    value={horarioParaVisualizar.situacao || 'N/A'} 
                    InputProps={{ readOnly: true }}
                    sx={{ width: '50%' }}
                  />
                </Box>
                
                <TextField 
                  label="Nome" 
                  value={horarioParaVisualizar.nome || 'N/A'} 
                  InputProps={{ readOnly: true }}
                  fullWidth
                />
                
                <Box sx={{ display: 'flex', gap: 2 }}>
                  <TextField 
                    label="Data Início" 
                    value={horarioParaVisualizar.diaInicio ? formatarDataParaExibicao(horarioParaVisualizar.diaInicio) : 'N/A'} 
                    InputProps={{ readOnly: true }}
                    sx={{ width: '50%' }}
                  />
                  <TextField 
                    label="Data Fim" 
                    value={horarioParaVisualizar.diaFim ? formatarDataParaExibicao(horarioParaVisualizar.diaFim) : 'N/A'} 
                    InputProps={{ readOnly: true }}
                    sx={{ width: '50%' }}
                  />
                </Box>
                
                <Box sx={{ display: 'flex', gap: 2 }}>
                  <TextField 
                    label="Hora Início" 
                    value={horarioParaVisualizar.horaInicio || 'N/A'} 
                    InputProps={{ readOnly: true }}
                    sx={{ width: '33%' }}
                  />
                  <TextField 
                    label="Duração (minutos)" 
                    value={horarioParaVisualizar.duracao_minuto || 'N/A'} 
                    InputProps={{ readOnly: true }}
                    sx={{ width: '33%' }}
                  />
                  <TextField 
                    label="Hora Fim" 
                    value={horarioParaVisualizar.horaFim || calcularHoraFim(horarioParaVisualizar.horaInicio, horarioParaVisualizar.duracao_minuto)} 
                    InputProps={{ readOnly: true }}
                    sx={{ width: '33%' }}
                  />
                </Box>
                
                <Box sx={{ display: 'flex', gap: 2 }}>
                  <TextField 
                    label="Local" 
                    value={buscarLocalPorId(horarioParaVisualizar.local)?.nome || 'N/A'} 
                    InputProps={{ readOnly: true }}
                    sx={{ width: '50%' }}
                  />
                  <TextField 
                    label="Número Máximo de Clientes" 
                    value={horarioParaVisualizar.numeroMaximoClientes || 'N/A'} 
                    InputProps={{ readOnly: true }}
                    sx={{ width: '50%' }}
                  />
                </Box>
                
                <TextField 
                  label="Serviço" 
                  value={(() => {
                    
                    // Priorizar servicoId, depois servico (para compatibilidade)
                    let servicoId = horarioParaVisualizar.servicoId || horarioParaVisualizar.servico;
                    
                    // Se não tem serviço no horário, tentar buscar do horarioSelecionado (dados originais)
                    if (!servicoId && horarioSelecionado) {
                      servicoId = horarioSelecionado.servicoId || horarioSelecionado.servico;
                    }
                    
                    const servico = buscarServicoPorId(servicoId);
                    
                    // Retornar apenas o nome do serviço
                    return servico?.nome || 'N/A';
                  })()} 
                  InputProps={{ readOnly: true }}
                  fullWidth
                />

                <TextField 
                  label="Colaborador" 
                  value={buscarColaboradorPorId(horarioParaVisualizar.colaborador)?.nome_completo || buscarColaboradorPorId(horarioParaVisualizar.colaborador)?.nome || 'N/A'} 
                  InputProps={{ readOnly: true }}
                  fullWidth
                />
                
                <Box sx={{ display: 'flex', gap: 2 }}>
                  <TextField 
                    label="Cargo do Colaborador" 
                    value={horarioParaVisualizar.colaboradorCargo || 'N/A'} 
                    InputProps={{ readOnly: true }}
                    sx={{ width: '50%' }}
                  />
                  <TextField 
                    label="Departamento do Colaborador" 
                    value={horarioParaVisualizar.colaboradorDepartamento || 'N/A'} 
                    InputProps={{ readOnly: true }}
                    sx={{ width: '50%' }}
                  />
                </Box>
                
                <TextField 
                  label="Dias da Semana" 
                  value={(horarioParaVisualizar.diasDaSemana || horarioParaVisualizar.diasSelecionados || []).map(dia => diasSemana[dia]).join(', ') || 'N/A'} 
                  InputProps={{ readOnly: true }}
                  fullWidth
                />
                
                <Box sx={{ display: 'flex', gap: 2 }}>
                  <TextField 
                    label="Capacidade" 
                    value={(() => {
                      // Se não tiver capacidade no horário, buscar do local
                      if (!horarioParaVisualizar.capacidade) {
                        const local = buscarLocalPorId(horarioParaVisualizar.local);
                        return local?.capacidade || 'N/A';
                      }
                      return horarioParaVisualizar.capacidade || 'N/A';
                    })()} 
                    InputProps={{ readOnly: true }}
                    sx={{ width: '33%' }}
                  />
                  <TextField 
                    label="Andar" 
                    value={(() => {
                      // Se não tiver andar no horário, buscar do local
                      if (!horarioParaVisualizar.andar) {
                        const local = buscarLocalPorId(horarioParaVisualizar.local);
                        return local?.andar || 'N/A';
                      }
                      return horarioParaVisualizar.andar || 'N/A';
                    })()} 
                    InputProps={{ readOnly: true }}
                    sx={{ width: '33%' }}
                  />
                  <TextField 
                    label="Bloco" 
                    value={(() => {
                      // Se não tiver bloco no horário, buscar do local
                      if (!horarioParaVisualizar.bloco) {
                        const local = buscarLocalPorId(horarioParaVisualizar.local);
                        return local?.bloco || 'N/A';
                      }
                      return horarioParaVisualizar.bloco || 'N/A';
                    })()} 
                    InputProps={{ readOnly: true }}
                    sx={{ width: '33%' }}
                  />
                </Box>
                
                <TextField 
                  label="Status" 
                  value={calcularStatus(horarioParaVisualizar.diaInicio, horarioParaVisualizar.diaFim)} 
                  InputProps={{ readOnly: true }}
                  fullWidth
                />
              </Box>
            )}
          </DialogContent>
          <DialogActions sx={{ 
            padding: 2,
            backgroundColor: (theme) => theme.palette.mode === 'dark' ? '#1976d2' : '#E3F2FD',
            borderTop: 1,
            borderColor: 'divider'
          }}>
            <Button 
              variant="contained" 
              color="primary"
              onClick={handleCloseView}
            >
              FECHAR
            </Button>
          </DialogActions>
        </Dialog>
      </Box>
    </AcessoRestrito>
  );
}

const diasSemana = {
  0: 'Domingo',
  1: 'Segunda-feira',
  2: 'Terça-feira',
  3: 'Quarta-feira',
  4: 'Quinta-feira',
  5: 'Sexta-feira',
  6: 'Sábado'
}; 